import React from 'react';
import useStyle from './style';
import cx from '@/utils/cx';

const LayoutMain = ({
  children,
  className,
  ...rest
}) => {
  const classes = useStyle();

  return (
    <main
      className={cx(classes.layoutMain, className)}
      {...rest}
    >
      {children}
    </main>
  );
};

export default LayoutMain;
